import React, { useState, useEffect, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { MissionScreenerSubCard, MissionSubCardHorizontalDivider } from "./MissionLayoutComponents";
import { useAlert } from 'react-alert';

import Timeline from "./Timeline";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { UserContext } from "../../../../UserContext";

import { Survey, Model, StylesManager } from "survey-react";
import { userSurveyTheme } from "./SurveyThemeJson";
import { userSurveyThemeMobile } from "./SurveyThemeJsonMobile";
import SurveyAPI from "../../../api/api_calls/SurveyAPI";


function MissionSurvey({ mission, userMissionState, refreshMissionStatus }) {

    return (
        <>
            <MissionScreenerSubCard>
                <Timeline mission={mission} userMissionState={userMissionState} />
                <MissionSubCardHorizontalDivider showMobile={true} showDesktop={false} />
            </MissionScreenerSubCard>
            <SurveyCard mission={mission} refreshMissionStatus={refreshMissionStatus} />
        </>

    )
}

function SurveyCard({ mission, refreshMissionStatus }) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const navigate = useNavigate();
    const alert = useAlert();
    const [surveyModel, setSurveyModel] = useState(null);
    const [loadingSurvey, setLoadingSurvey] = useState(true);
    const [surveyId, setSurveyId] = useState(null);
    const [survey, setSurvey] = useState(null);
    const missionId = mission.id;
    const STORAGE_ITEM_KEY = "survey-" + user.first_name + "-" + surveyId;


    const onSurveyComplete = useCallback(async (sender) => {
        const response = await SurveyAPI.create_response(sender.data, missionId, surveyId, navigate)

        if (response.success) {
            alert.show("Survey submitted!", { type: 'success' })
            refreshUser();
            refreshMissionStatus();
        } else {
            alert.show("Unable to submit survey. Please contact info@despark.io", { type: 'error' })
        }
    }, [missionId, surveyId, refreshMissionStatus, alert, navigate]);

    // Save the survey data to local storage
    function saveSurveyData(survey) {
        const data = survey.data;
        data.pageNo = survey.currentPageNo;
        window.localStorage.setItem(STORAGE_ITEM_KEY, JSON.stringify(data));
    }

    // Restore the survey data from local storage
    function restoreSurveyData(survey) {
        const prevData = window.localStorage.getItem(STORAGE_ITEM_KEY) || null;
        if (prevData) {
            const data = JSON.parse(prevData);
            survey.data = data;
            if (data.pageNo) {
                survey.currentPageNo = data.pageNo;
            }
        }
    }

    // First effect just loads the survey model and sets the ID
    useEffect(() => {
        const GetSurvey = async () => {
            const response = await SurveyAPI.show_survey(missionId);

            if (response.success) {
                const tempSurvey = new Model(response.survey);
                setSurveyModel(tempSurvey);
                setSurveyId(response.survey_id);
            } else {
                alert.show("Unable to load survey. Please refresh the page and try again. If the issue persists, contact info@despark.io", { type: 'error' })
            }
        }

        GetSurvey();
    }, [missionId]);

    // Second effect sets up the screener with the callback once we have both pieces
    useEffect(() => {
        if (surveyModel && surveyId) {
            surveyModel.applyTheme(innerWidth < 840 ? userSurveyThemeMobile : userSurveyTheme);
            surveyModel.onComplete.add(onSurveyComplete);
            surveyModel.completeText = "Continue";
            surveyModel.nextText = "Continue";
            surveyModel.onValueChanged.add(saveSurveyData);
            surveyModel.onCurrentPageChanged.add(saveSurveyData);
            restoreSurveyData(surveyModel);
            setSurvey(surveyModel);
            setLoadingSurvey(false);
        }
    }, [surveyModel, surveyId, onSurveyComplete]);

    return (
        <div className="screener-container-card">
            {loadingSurvey ? <CenteredLoadingIcon /> : <Survey model={survey} />}
        </div>
    )
}


export default MissionSurvey;